var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertErrorFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0119 3.33301H12.9881L3.33331 12.9878V27.0115L12.9881 36.6663H27.0119L36.6666 27.0115V12.9878L27.0119 3.33301ZM18.935 11.6663H21.0648V16.8515L20.5091 23.2405H19.4908L18.935 16.8515V11.6663ZM20 28.333C19.1666 28.333 18.5185 27.6851 18.5185 26.8516C18.5185 26.018 19.1664 25.3701 20 25.3701C20.8102 25.3701 21.4814 26.0413 21.4814 26.8513C21.4814 27.6618 20.8102 28.333 20 28.333Z",
    fill: "#ED0007"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertErrorFilled);
export default __webpack_public_path__ + "static/media/alert-error-filled.18db2ec5726a5ef46da4f63e97578de3.svg";
export { ForwardRef as ReactComponent };